<div class="app-content content" *ngIf="loadPage">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
      </div>
      <div class="content-body">
        <!-- Basic form layout section start -->
        <section id="horizontal-form-layouts">
          <div class="row">
            <div class="col-md-12">
              <m-card >
                <ng-container mCardHeaderTitle>
                  <h4 class="font-medium-3">Crear cuenta de egresado</h4>
                </ng-container>
                <ng-container mCardBody>
                  <div class="card-text">
                    <p>Completa los campos del formulario para registrar a un nuevo egresado.</p>
                  </div>
                  <form class="form form-horizontal" [formGroup]="addEgresadoForm">
                    <div class="form-body">
                      <h4 class="form-section text-bold-500"><i class="la la-user blue4 font-medium-5"></i> Acerca del egresado</h4>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row mx-auto">
                            <label class="col-md-3 label-control" for="userinput1">Nombre</label>
                            <div class="col-md-9">
                              <input type="text" id="userinput1" class="form-control"
                                placeholder="Ximena" formControlName="name">
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row mx-auto">
                            <label class="col-md-3 label-control" for="userinput2">Apellido</label>
                            <div class="col-md-9">
                              <input type="text" id="userinput2" class="form-control"
                                placeholder="Washington Bieber" formControlName="lastName">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row last mx-auto">
                            <label class="col-md-3 label-control" for="userinput3">Generación</label>
                            <div class="col-md-9">
                              <input type="text" id="userinput3" class="form-control"
                                placeholder="2019-2021" formControlName="generation">
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row last mx-auto">
                            <label class="col-md-3 label-control" for="userinput4">Área de especialidad</label>
                            <div class="col-md-9">
                              <select class="form-control input-md" formControlName="speciality">
                                <option *ngFor="let area of _listaAreas" [value]="area.idArea">{{area.descripcion}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h4 class="form-section text-bold-500"><i class="feather ft-log-in blue4 font-medium-4"></i> Acceso al sistema</h4>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group row mx-auto">
                          <label class="col-md-3 label-control" for="userinput5">Usuario (matrícula)</label>
                          <div class="col-md-9">
                            <input class="form-control text-uppercase" type="text" placeholder="UTP0138498" id="userinput5"
                              formControlName="username">
                          </div>
                        </div>
                        <div class="form-group row mx-auto">
                          <label class="col-md-3 label-control" for="userinput6">Contraseña</label>
                          <div class="col-md-9">
                            <input class="form-control text-uppercase" readonly [value]="addEgresadoForm.get('username').value" type="text" placeholder="UTP0138498" id="userinput6">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-actions text-right">
                      <button type="submit" [disabled]="addEgresadoForm.invalid" (click)="trySubmit()" class="btn btn-navy">
                        <i class="la la-check"></i> Crear cuenta
                      </button>
                    </div>
                  </form>
                </ng-container>
              </m-card>
            </div>
          </div>
          
        </section>
        <div class="p-2 mt-2"></div>
        <div class="p-2 mt-2"></div>
      </div>
    </div>
  </div>
  